import React, { FC } from 'react'
import styled from 'styled-components'

import { AccountDocumentType } from '../../../../../graphql/search'
import { PractitionerSettings } from '../../../../../lib/practitioner-settings/types'
import { AccountDocumentForm } from './AccountDocumentForm'

export interface OtherDocumentsSectionProps {
  className?: string
  settings: PractitionerSettings
}

const StyledHeader = styled.h2`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 24px;
  color: #001b36;
  margin-bottom: 32px;
`

const StyledSubheader = styled.h4`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 18px;
  color: #001b36;
`

const StyledDescription = styled.p`
  && {
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
    font-size: 1rem;
    margin-bottom: 1rem;
  }
`

const OtherDocumentsSection: FC<OtherDocumentsSectionProps> = ({ className, settings }) => {
  return (
    <section className={className}>
      <StyledHeader>Optional forms and documents</StyledHeader>
      <StyledSubheader>Tax exemption or reseller certificate</StyledSubheader>
      <StyledDescription>
        Upload your sales tax exemption or reseller certificate. Changes may take up to one business
        day to go into effect.
      </StyledDescription>
      <AccountDocumentForm documentType={AccountDocumentType.TaxExemption} settings={settings} />
    </section>
  )
}

export default OtherDocumentsSection
